let undoStack = [];

const set = (stack) => {
  undoStack = stack;
  return stack.length;
};

const get = () => undoStack;

export default {
  set,
  get,
};
